// Styles
import styles from './MainLayout.module.sass'

// Components
import Header from '@components/v25/ft1/common/header/Header'

const MainLayout = ({
  children,
  backgroundColor,
  displayCounter = false,
  displayHeader = true,
  discount
}: {
  children: React.ReactNode
  backgroundColor?: string
  displayCounter?: boolean
  displayHeader?: boolean
  discount?: number
}) => {
  return (
    <div
      className={`getaway-scan-v25 ${styles.container}`}
      style={{ backgroundColor: backgroundColor || '#E5E5E5' }}
    >
      {displayHeader && (
        <Header displayCounter={displayCounter} discount={discount} />
      )}

      <main
        className={`${styles.main} ${styles[displayCounter ? 'md' : 'sm']} ${
          !displayHeader ? styles.hideHeader : ''
        }`}
      >
        {children}
      </main>
    </div>
  )
}

export default MainLayout
